function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorseCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC61B"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D48B07"
    },
    points: "176.373,109.961 268.85,202.44 188.199,202.44  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D48B07"
    },
    d: "M350.522,111.863L188.199,406.45l103.114,103.114c119.224-16.453,212.221-114.991,220.122-236.741 L350.522,111.863z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#824A25"
    },
    d: "M316.594,206.657c-13.983-2.446-20.704-20.485-15.012-40.293 c3.936-13.695,23.064-36.016,34.494-48.488c4.436-4.839,10.128-3.843,11.49,2.01c3.51,15.086,8.59,41.641,4.655,55.336 C346.527,195.029,330.576,209.103,316.594,206.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#663C0E"
    },
    d: "M319.822,213.492c-1.458,0-2.912-0.122-4.358-0.376l0,0c-6.939-1.214-12.966-5.404-16.965-11.802 c-5.915-9.457-7.118-23.202-3.22-36.762c4.108-14.289,21.823-35.68,35.961-51.107c3.91-4.267,9.069-6.07,13.812-4.825 c4.418,1.158,7.746,4.815,8.901,9.78c4.372,18.789,8.714,44.215,4.57,58.635C352.384,198.389,335.963,213.49,319.822,213.492z  M341.304,121.915c-0.122,0.109-0.255,0.241-0.395,0.393c-18.372,20.046-30.41,36.764-33.025,45.868 c-2.888,10.043-2.239,19.832,1.736,26.186c2.057,3.291,4.784,5.254,8.102,5.835l0,0c10.592,1.857,23.49-10.418,28.193-26.786 C348.486,164.473,346.803,145.722,341.304,121.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C33"
    },
    d: "M195.406,206.657c13.983-2.446,20.704-20.485,15.012-40.293 c-3.936-13.695-23.064-36.016-34.494-48.488c-4.436-4.839-10.128-3.843-11.49,2.01c-3.51,15.086-8.59,41.641-4.655,55.336 C165.473,195.029,181.422,209.103,195.406,206.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#663C0E"
    },
    d: "M192.176,213.492c-16.141,0-32.561-15.101-38.7-36.457c-4.143-14.419,0.198-39.845,4.57-58.635 c1.155-4.965,4.484-8.621,8.901-9.78c4.746-1.246,9.904,0.56,13.812,4.825c14.138,15.427,31.854,36.817,35.961,51.107 c3.898,13.56,2.694,27.305-3.222,36.762c-3.999,6.396-10.023,10.588-16.963,11.802C195.091,213.37,193.634,213.492,192.176,213.492z  M170.694,121.915c-5.499,23.809-7.182,42.56-4.613,51.497c4.705,16.368,17.601,28.641,28.193,26.786 c3.319-0.581,6.044-2.544,8.102-5.835c3.975-6.356,4.624-16.144,1.736-26.186c-2.617-9.104-14.653-25.822-33.025-45.868 C170.951,122.154,170.818,122.023,170.694,121.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA714B"
    },
    d: "M151.704,269.328c0,94.701,46.695,163.166,104.296,163.166s104.296-68.463,104.296-163.166 S313.601,147.122,256,147.122S151.704,174.626,151.704,269.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965E38"
    },
    d: "M256,147.123c-0.481,0-0.958,0.007-1.436,0.01v285.334c0.479,0.009,0.957,0.026,1.436,0.026 c57.601,0,104.296-68.463,104.296-163.166S313.601,147.123,256,147.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C33"
    },
    d: "M151.704,269.328c0,74.473,28.884,132.696,69.234,154.181c10.081-1.672,17.174-10.717,17.263-32.797 c0.248-61.766-33.573-180.221-47.207-225.435C167.057,182.882,151.704,215.056,151.704,269.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#824A25"
    },
    d: "M360.296,269.328c0,74.473-28.884,132.696-69.234,154.181c-10.081-1.672-17.174-10.717-17.263-32.797 c-0.248-61.766,33.573-180.221,47.207-225.435C344.943,182.882,360.296,215.056,360.296,269.328z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A3A3A"
    },
    cx: 206.938,
    cy: 259.155,
    r: 8.654
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1E1D1D"
    },
    cx: 305.08,
    cy: 259.155,
    r: 8.654
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#663C0E"
    },
    cx: 254.121,
    cy: 380.19,
    rx: 77.748,
    ry: 50.166
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59330E"
    },
    d: "M331.881,380.183c0-27.61-34.576-50.002-77.317-50.155v100.311 C297.303,430.187,331.881,407.793,331.881,380.183z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A3A3A"
    },
    cx: 214.161,
    cy: 380.19,
    r: 10.53
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1E1D1D"
    },
    cx: 294.081,
    cy: 380.19,
    r: 10.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M283.739,138.487c-14.491-8.685-67.829-15.867-77.557,15.96 c-16.218,53.06,48.426,84.394,48.426,84.394l-13.486-37.986c0,0,44.618,34.018,59.956,36.18l-19.816-31.117l44.71,10.866 C325.97,216.783,323.493,162.309,283.739,138.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M254.609,238.84l-0.045-0.128v0.105C254.592,238.833,254.609,238.84,254.609,238.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E1D1D"
    },
    d: "M301.077,237.034l-19.816-31.117l44.71,10.866c0,0-2.477-54.474-42.23-78.296 c-5.56-3.332-16.839-6.432-29.175-7.204v79.4C268.986,220.908,291.154,235.635,301.077,237.034z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorseCoin);
export default __webpack_public_path__ + "static/media/horse-coin.148b25e289cf8ec1be6e1a3909e1dcc8.svg";
export { ForwardRef as ReactComponent };